var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77486 1.22456C9.01893 1.46864 9.01893 1.86437 8.77486 2.10845L2.10784 8.77546C1.86376 9.01954 1.46803 9.01954 1.22395 8.77546C0.979875 8.53139 0.979876 8.13566 1.22395 7.89158L7.89097 1.22456C8.13505 0.980485 8.53078 0.980485 8.77486 1.22456Z",
    fill: "#C8172F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77495 8.77583C8.53087 9.01991 8.13514 9.01991 7.89107 8.77583L1.22405 2.10881C0.979969 1.86474 0.979969 1.46901 1.22405 1.22493C1.46812 0.980853 1.86385 0.980853 2.10793 1.22493L8.77495 7.89195C9.01903 8.13603 9.01903 8.53175 8.77495 8.77583Z",
    fill: "#C8172F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosered);
export default __webpack_public_path__ + "static/media/Closered.043d3ecee2e648e4c1d00cad63981555.svg";
export { ForwardRef as ReactComponent };